import React from 'react';
import {TextInput, Create, SimpleForm, required, minLength,BooleanInput, ReferenceInput, SelectInput} from 'react-admin';
import {makeStyles, Theme} from '@material-ui/core';
import BaseListActions from '../BaseListActions';
import {CURRENCIES} from '../../consts/Names';

const useStyles = makeStyles((theme: Theme) => ({
   formContainer: {
      width: '80%',
      padding: '0 1em 1em 1em'
   },
   textFld: {
      width: '300px',
      marginTop: '1em'
   }
}));

export const CurrencyCreate = (props) => {
   const {theme, basePath} = props;
   const classes = useStyles(theme);

   return (
      <Create {...props} actions={<BaseListActions basePath={basePath} />}>
         <SimpleForm className={classes.formContainer} redirect="list">
            <TextInput className={classes.textFld} label="Name" source='name' />
            <TextInput className={classes.textFld} label="Symbol" source='symbol' />
         </SimpleForm>
      </Create>
   );
};
